import { createContext, ReactNode, useContext, useMemo, useState } from 'react';
import { Locale } from '../types/global';
import { SUPPORTED_LANGUAGES } from '../i18n';

type LanguageContextValue = {
  locale: Locale;
  setLocale: (locale: Locale) => void;
  options: Array<{ value: Locale; label: string }>;
};

const LanguageContext = createContext<LanguageContextValue | undefined>(undefined);

export const LanguageProvider = ({ children }: { children: ReactNode }) => {
  const [locale, setLocale] = useState<Locale>('en');

  const value = useMemo(
    () => ({
      locale,
      setLocale,
      options: (Object.keys(SUPPORTED_LANGUAGES) as Locale[]).map((lang) => ({
        value: lang,
        label: SUPPORTED_LANGUAGES[lang]
      }))
    }),
    [locale]
  );

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return ctx;
};
